'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vuex = require('vuex');

exports.default = {
    data: function data() {
        return {};
    },
    computed: _extends({}, (0, _vuex.mapGetters)(['getAnswers']), {
        getStatus: function getStatus() {
            if (this.status !== undefined) {
                return this.status;
            } else {
                var status = void 0;
                if (this.getGivenAnswers == 0) {
                    status = 'new';
                } else {
                    status = 'inprogress';
                }
                return status;
            }
        },
        percentageClass: function percentageClass() {
            var percentage = void 0;
            if (this.status == 'finished') {
                percentage = 100;
            } else {
                percentage = (this.getGivenAnswers / this.getTotal * 100).toFixed();
            }
            return 'progress__circle--' + percentage;
        },
        getGivenAnswers: function getGivenAnswers() {
            if (this.current !== undefined) {
                return this.current;
            } else {
                var givenAnswers = 0;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.getAnswers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var answer = _step.value;

                        if (typeof answer.answer !== 'undefined' && answer.answer !== '') {
                            givenAnswers++;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return givenAnswers;
            }
        },
        getTotal: function getTotal() {
            if (this.total !== undefined) {
                return this.total;
            } else {
                var answersToBeGiven = 0;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = this.getAnswers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var answer = _step2.value;

                        if (answer.display === true) {
                            answersToBeGiven++;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return answersToBeGiven;
            }
        }
    }),
    methods: {},
    props: ['current', 'total', 'status']
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/progress-assessment.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/progress-assessment.vue
// module chunks = 0